import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, HostBinding } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EuiTableSelectableRowService } from '../services/eui-table-selectable-row.service';

@Component({
    // tslint:disable-next-line
    selector: 'tr[isSelectable]',
    templateUrl: './eui-table-selectable-row.component.html',
})

export class EuiTableSelectableRowComponent implements OnInit, OnDestroy, OnChanges {

    @Input() isSelectable: any;
    @Input() isChecked = false;

    @HostBinding('class')
    get cssClasses() {
        return [
            'eui-table__row',
            this.isSelectable ? `eui-table__row--selectable` : ``,
            this.isChecked ? `eui-table__row--selected` : ``,
        ].join(' ').trim();
    }

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private euiTableSelectableRowService: EuiTableSelectableRowService) {}

    ngOnChanges(c: SimpleChanges) {
        this.euiTableSelectableRowService.addRow(this.isSelectable);
        this.isChecked = this.euiTableSelectableRowService.selectedRows$.value.filter(s => s.id === this.isSelectable.id).length > 0;
    }

    ngOnInit() {
        this.euiTableSelectableRowService.selectedRows$.pipe(takeUntil(this.destroy$)).subscribe((selected) => {
            this.isChecked = selected.filter(s => s.id === this.isSelectable.id).length > 0;
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    public toggleCheckedState(value: boolean) {
        this.isChecked = value;

        if (this.isChecked) {
            this.euiTableSelectableRowService.addSelectedRow(this.isSelectable);
        } else {
            this.euiTableSelectableRowService.removeSelectedRow(this.isSelectable);
        }
    }
}
